import { render } from "./CommonAuthorFour.vue?vue&type=template&id=4067077d"
import script from "./CommonAuthorFour.vue?vue&type=script&lang=js"
export * from "./CommonAuthorFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__